import * as React from 'react';
import { observer } from 'src/utils/mobx-react';
import { I18n } from 'src/domains/layouts/webview/components/language/I18n';
import { NavigationChevronIconWrapper } from 'src/domains/layouts/webview/components/navigationPanel/NavigationPanel.style';
import { PromotedEventsLink } from '../NavigationSidebar/NavigationSidebar.style';
import { useCommon } from 'src/domains/common/Common';
import { StarRouter } from 'src/domains/layouts/state/router/StarRouter';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';
import { AppLayoutsState } from 'src/domains/layouts/state/AppLayouts.state';

export const PromotedEventsNavigationLink = observer('PromotedEventsNavigationLink', (): React.ReactElement | null => {
    const common = useCommon();
    const { promotedEventsState, overlay } = AppLayoutsState.get(common);
    const { promotedEvents } = ConfigComponents.get(common).config;

    const starRouter = StarRouter.get(common);

    const redirectToPromotedEvents = (): void => {
        starRouter.redirectToPromotedEvents();
        overlay.toggleMenu();
    };

    const promotedSports = promotedEventsState.promotedSportsToShow;
    const promotedEventsLabel = promotedEvents.label;
    const shouldShowPromotedEventsLink = promotedEventsLabel !== '';

    if (shouldShowPromotedEventsLink && promotedSports.length > 0) {
        return (
            <PromotedEventsLink onClick={redirectToPromotedEvents}>
                <I18n
                    langKey='left-menu.star-events.label'
                    defaultText='{starEventsLabel}'
                    params={{ starEventsLabel: promotedEventsLabel }}
                />

                <NavigationChevronIconWrapper position='right' />
            </PromotedEventsLink>
        );
    }

    return null;
});
